<template>
  <div class="col-lg-4 col-md-6 col-12" >
    <div class="pb-0 card-header">
      <div class="d-lg-flex">
        <i class="fa-solid fa-truck-fast icon-primary mt-2"></i>
        <h6 class="ms-2 mb-3">{{ $t('key_orderBackTrackingInfo_tracking') }}</h6>
      </div>
    </div>
    <div v-if="items" class="pb-0 card-body">
      <div class="timeline timeline-one-side">
        <div v-for="(item) of items" :key="item._id" class="timeline-block mb-3">
          <span class="timeline-step">
            <i :class="getIcon(item)" class="text-secondary"></i>
          </span>
          <div class="timeline-content">
            <h6 class="text-sm font-weight-bold mb-0" :class="getColor(item)">
              {{ getTranslation(item) }}
            </h6>
            <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
              {{ $dateUtils.toDDMMYYYYHH(item.date) }}
            </p>
            <!-- <span v-if="item.status == 'EN_PROCESO'" class="badge badge-sm me-1 bg-gradient-success">
              {{ inProgressPercentage() }}%
            </span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="pb-0 card-footer" />
  </div>
</template>

<script>

  export default {
    name: "OrderTracking",
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      total: {
        type: Number,
        default: 0
      },
      requestedUnits: {
        type: Number,
        default: 1
      },
      completedUnits: {
        type: Number,
        default: 0
      }
    },
    methods: {
      getIcon(item){
        const icons = {
          REGISTRADO: "fa-solid fa-truck-ramp-box text-saved",
          EN_PROCESO: "fa-solid fa-box-open text-processing",
          FINALIZADO: "fa-solid fa-magnifying-glass text-located",
          CANCELADO: "fa-solid fa-xmark text-cancelled"
        };
        return `${icons[item.status] || "fa-solid fa-truck-ramp-box"} text-saved`;
      },
      getColor(item) {
        const colors = {
          REGISTRADO: "text-saved",
          EN_PROCESO: "text-processing",
          FINALIZADO: "text-fullfilled",
          CANCELADO: "text-cancelled"
        };
        return `${colors[item.status] || "text-saved"}`;
      },
      getTranslation(item){
        const icons = {
          REGISTRADO: this.$t('key_orderBackList_orderBackInformed'),
          EN_PROCESO: this.$t('key_orderBackList_orderBackInProcess'),
          FINALIZADO: this.$t('key_orderBackList_orderBackFinished'),
          CANCELADO: this.$t('key_orderStatus_cancelled')
        };
        return `${icons[item.status] || this.$t('key_unknown_status')}`;
      },
      inProgressPercentage() {
        return Math.round((this.completedUnits/this.requestedUnits)*100);
      }
    }
  };

</script>

<style>

  .icon-primary {
    color: #4A7062 !important;
  }

</style>